module.exports = __webpack_public_path__ + "img/ABW.18e224d2.svg";